import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DocIcon } from './DocIcon';

export const ImageLightbox = ({ src, alt, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <Box
      onClick={onClose}
      className="fixed inset-0 flex items-center justify-center cursor-pointer"
      sx={{ zIndex: 1500, background: 'rgba(0,0,0,.85)', padding: '32px' }}
    >
      <Box
        component="button"
        aria-label={t('Close fullscreen view')}
        onClick={onClose}
        className="absolute inline-flex items-center justify-center cursor-pointer"
        sx={{
          top: '18px',
          right: '18px',
          border: 'none',
          background: 'rgba(255,255,255,.12)',
          borderRadius: '99px',
          padding: '8px',
          ':hover': { background: 'rgba(255,255,255,.22)' },
        }}
      >
        <DocIcon name="close" size={22} color="#ffffff" />
      </Box>
      <Box
        component="img"
        src={src}
        alt={alt || ''}
        onClick={(event) => event.stopPropagation()}
        className="cursor-default"
        sx={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          borderRadius: '10px',
        }}
      />
    </Box>
  );
};
